import { Action, Server } from '@nextforce/api'

export async function performAction<T = void>(
  server: Server,
  action: Action | undefined
): Promise<T | void> {
  if (!action) {
    return
  }

  let response: T | undefined

  switch (action.method) {
    case 'update':
      response = await server.put<T>(action.uri, action.params ?? {})
      break
    case 'create':
      response = await server.post<T>(action.uri, action.params ?? {})
      break
    case 'delete':
      await server.delete(action.uri)
      break
    default:
      throw new Error('Illegal action method')
  }

  return response
}
